

<div class="my-4 text-center access-denied" style="height: 66vh">
    <h4 class="fs-16">Access Denied</h4>
    <div> You are not authorized to view this page. Please reach out to
        <a href="mailto:myWizardIOM.Support@accenture.com"><u>myWizardIOM.Support</u></a> for access.
    </div>
</div>


<!-- <app-header></app-header> -->
